import * as Icons from "lucide-react";
import React from "react";
import { LucideIconProps } from "./LucideIcon.types";

/**
 * A `lucide-react` icon looked up by name, for names that come from data (it is what
 * `IconFromSet` uses for the "lucide" set). When the icon is known in code, import it from
 * `lucide-react` directly: it keeps the bundle smaller and is type-checked.
 */
export const LucideIcon = React.forwardRef<SVGSVGElement, LucideIconProps>(
  (props, ref) => {
    const { name, color, size = 6, className, preserveAspectRatio } = props;
    if (!name) return null;
    const LucideIconComponent = Icons[`${name}Icon`];
    if (!LucideIconComponent) {
      throw new Error(`Lucide icon "${name}" not found`);
    }
    return (
      <LucideIconComponent
        color={color}
        size={size}
        className={className}
        width={
          props?.style?.width || size
            ? `${props?.style?.width || size * 4}px`
            : undefined
        }
        height={
          props?.style?.height || size
            ? `${props?.style?.height || size * 4}px`
            : undefined
        }
        ref={ref}
        preserveAspectRatio={preserveAspectRatio}
      />
    );
  }
);

LucideIcon.displayName = "Icon";
